import React from 'react'
import { Input } from 'antd'

interface QuickEditCellProps {
  value: string
  onChange: (value: string) => void
  onBlur: () => void
  disabled?: boolean
  suffix?: React.ReactNode
  allowPattern?: RegExp
  className?: string
}

export const QuickEditCell: React.FC<QuickEditCellProps> = ({
  value,
  onChange,
  onBlur,
  disabled,
  suffix,
  allowPattern,
  className
}) => {
  return (
    <Input
      value={value}
      onChange={(event) => {
        const nextValue = event.target.value

        if (allowPattern && !allowPattern.test(nextValue)) {
          return
        }

        onChange(nextValue)
      }}
      onBlur={onBlur}
      onPressEnter={(event) => event.currentTarget.blur()}
      onClick={(event) => event.stopPropagation()}
      onFocus={(event) => event.stopPropagation()}
      disabled={disabled}
      suffix={suffix}
      className={className}
    />
  )
}
